import { render, staticRenderFns } from "./OsListServico.vue?vue&type=template&id=5f5ed9ec&"
import script from "./OsListServico.vue?vue&type=script&lang=js&"
export * from "./OsListServico.vue?vue&type=script&lang=js&"
import style0 from "./OsListServico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports